export enum SampleRequestReason {
  Compromised = 'compromised',
  Incorrect = 'incorrect',
  Insufficient = 'insufficient',
  Other = 'other',
}
